export enum RESOURCES {
    Companies = "Companies",
    Users = "Users",
    ConfigurationFiles = "ConfigurationFiles"
}
